let config = {}

if (process.env.NODE_ENV === 'development') {
    config = {
        API_URL: 'https://gustoreich.at/API/api/v1/',
        // API_URL: "http://localhost/book-you-room/api/v1/",

        // GOOGLE_PLACE_API_KEY: 'AIzaSyDfNd2unLER9xtPVJPR0KFVpN_QdK5zf60',
        GOOGLE_PLACE_API_KEY: 'AIzaSyBdFRcM7GFoZH7zriMnwhKsoZaOAFstEtQ',
        CURRENCY_SYMBOL: '€',
        availableCountries: ["AT", "DE"],
        HOTJAR_ID : '2694112',
        PROD_MODE : false,
    }
} else if (process.env.NODE_ENV === 'production') {
    config = {
        API_URL: 'https://gustoreich.at/API/api/v1/',
        // GOOGLE_PLACE_API_KEY: 'AIzaSyDfNd2unLER9xtPVJPR0KFVpN_QdK5zf60',
        GOOGLE_PLACE_API_KEY: 'AIzaSyBdFRcM7GFoZH7zriMnwhKsoZaOAFstEtQ',
        CURRENCY_SYMBOL: '€',
        availableCountries: ["AT", "DE"],
        HOTJAR_ID : '2694112',
        PROD_MODE : true,
    }
}

export default config
